import * as React from 'react'
import moment, { Moment } from 'moment'
import {
  Button,
  DatePicker,
  Modal,
  ModalProps,
  Icon,
  Popover,
} from 'components/common'

export interface ExportLedgerModalProps extends Omit<ModalProps, 'onOk'> {
  onOk: (date: Moment) => void
  loading: boolean
}

export const ExportLedgerModal = ({
  visible,
  onCancel,
  onOk,
  loading,
  ...rest
}: ExportLedgerModalProps) => {
  const [isPop, setIsPop] = React.useState<boolean>(false)
  const [date, setDate] = React.useState<Moment>(moment())
  const handleDateChange = (date: Moment, dateString: string) => {
    setDate(date)
    setIsPop(false)
  }
  const buttonCover = React.useMemo((): JSX.Element => {
    return (
      <div className="space-x-2">
        <Icon.CalendarTwoTone />
        <span>{date.format('YYYY年MM月')}</span>
      </div>
    )
  }, [date])

  return (
    <Modal
      title="現金出納をエクスポートする"
      visible={visible}
      onOk={() => onOk(date)}
      onCancel={onCancel}
      okText="エクスポートする"
      cancelText="キャンセル"
      confirmLoading={loading}
      {...rest}
    >
      <div className="space-y-4">
        <div>エクスポートの対象</div>
        <Popover
          title="月を選択"
          visible={isPop}
          onVisibleChange={setIsPop}
          trigger="click"
          content={
            <DatePicker
              picker="month"
              value={date}
              onChange={handleDateChange}
            />
          }
        >
          <Button onClick={() => setIsPop(!isPop)}>{buttonCover}</Button>
        </Popover>

        <div>
          対象期間に該当するすべての項目が一つのCSVファイルに出力されます。
        </div>
      </div>
    </Modal>
  )
}
